export const generateSlug = (tenantName, assessmentName) => {
  const nonAlphaNumericalOrHypen = /[^\w\d-]/g;
  const slug = `${tenantName} ${assessmentName}`
    .replace(/\s+/g, "-")
    .replace(nonAlphaNumericalOrHypen, "")
    .toLowerCase();

  return slug;
};
